<script>
import { mapState } from 'vuex'
import { formatter } from '@/helpers/formatter'
import NavigationLink from '@/components/common/header/NavigationLink.vue'
export default {
  name: 'CreditBalance',
  components: {
    NavigationLink
  },
  mixins: [formatter],
  props: {
    content: {
      type: String
    },
    linkParams: { type: Object }
  },
  computed: {
    ...mapState({
      credit: state => state.credit
    }),
    //show credit value
    creditBalanceContent() {
      let content =
        this.content || this.$t('component.credit.creditBalance.content')
      return content.replace(
        '{{creditBalance}}',
        this.formatCurrency(this.credit.creditBalance)
      )
    }
  }
}
</script>
<template>
  <NavigationLink
    v-if="linkParams"
    :link-params="linkParams"
    mobile
    @click="$emit('click')">
    <v-list-item-icon>
      <v-icon color="primary" large>mdi-currency-eur</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>{{ creditBalanceContent }}</v-list-item-title>
    </v-list-item-content>
  </NavigationLink>
  <h3
    v-else
    class="font-weight-regular secondary--text"
    v-html="creditBalanceContent"
  ></h3>
</template>
